import { render } from "./grades.vue?vue&type=template&id=eebbb838&scoped=true"
import script from "./grades.vue?vue&type=script&lang=js"
export * from "./grades.vue?vue&type=script&lang=js"

import "./grades.vue?vue&type=style&index=0&id=eebbb838&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eebbb838"]])

export default __exports__